import {FormattedMessage, IntlShape } from "react-intl";
import React from "react";
import {Authentication} from "../../model/Authentication";
import {
  Nav,
  OverlayTrigger,
} from "react-bootstrap";
import { faBars, faPowerOff } from '@fortawesome/free-solid-svg-icons'

import "./session-panel.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {OverlayInjectedProps} from "react-bootstrap/Overlay";
import ProfilePicture from "../components/profile-picture";
import {MenuLinkConfiguration} from "../../ui-configuration/my-licenses-configuration";

export interface SessionPanelContainerProps {
  intl: IntlShape;

  profileLink?: string;
  logoutLink?: string;

  show: boolean;
  onSetShow: (b: boolean) => void;

  links?: MenuLinkConfiguration;
}

export interface SessionPanelProps extends SessionPanelContainerProps {
  auth?: Authentication,
}
function SessionPanel(props: SessionPanelProps) {
  const {
    auth,
    logoutLink,
    links,
      show,
      onSetShow,
  } = props;
  const linkKeys = links ? Object.keys(links) : undefined;

  return (<>
    {auth && (
      <Nav className={"SessionPanel"}>
        <OverlayTrigger
            show={show}
            defaultShow={false}
            placement="bottom-end"
            delay={{ show: 250, hide: 400 }}
            onToggle={onSetShow}
            trigger={"click"}
            rootClose={true}
            overlay={(props: OverlayInjectedProps) => {
              const {
                show,
                hasDoneInitialMeasure,
                arrowProps,
                style,
                ...other
              } = props;
                return (
                <div className={"Session-panel-panel"}
                    data-test-user-menu={auth.userId}
                    id="header-nav-profile-dropdown"
                    {...other}
                    style={{
                      ...style,
                    }}
                >
                  <div className={"Session-panel-header"}>
                    <ProfilePicture userDisplayName={auth.userDisplayName} className={"icon"} />
                    <span>
                      {auth.userDisplayName
                          ? auth.userDisplayName
                          : <FormattedMessage
                              defaultMessage="Unknown"
                              description={"Fallback label for user name"}
                          />
                      }
                      {auth.userEmail && (<>
                          <br />
                          <em>{auth.userEmail}</em>
                      </>)}
                    </span>
                  </div>
                  <div className={"Session-panel-body"}>
                    {links && linkKeys && linkKeys.map((l) => {
                      const key = "menu-link-" + l;// .replace(/[^\w]/gi, "_");
                      return (
                        <a id={key} key={key} href={links[l]} target={"_blank"} rel="noopener noreferrer" className={l === 'My_Licenses' ? 'selected-item' : undefined}>
                          <span>
                            <FormattedMessage
                                defaultMessage="{link, select, My_Profile {My Profile} My_Licenses {My Licenses} other {{linkWithSpaces}}}"
                                description={"Profile menu item label. {link, select, other {{linkWithSpaces}}} prints the name of link with underscores replaced by space characters, inject ' value {translated value} ' between the 'select,' and 'other' to override and translate links."}
                                values={{
                                  link: l,
                                  linkWithSpaces: l.replaceAll('_', ' '),
                                }}
                            />
                          </span>
                        </a>
                      );
                    })}
                    {(links && linkKeys) && <hr /> }
                    <a
                        className={'logout-trigger'}
                        href={logoutLink}
                    >
                      <FontAwesomeIcon icon={faPowerOff} className="icon" fixedWidth={true} />
                      <span>
                        <FormattedMessage
                            defaultMessage="Logout"
                            description={"Profile menu item label for logging out"}
                        />
                      </span>
                    </a>
                  </div>
                  <div className={"Session-panel-arrow"}></div>
                </div>);}
            }
        >
            <button
                className={"Session-panel-toggle"}
            >
                  <ProfilePicture userDisplayName={auth.userDisplayName} />
                  <span className={"profile-name"}>
                      {auth.userDisplayName}
                  </span>
                  <FontAwesomeIcon className={"icon"} icon={faBars} fixedWidth={true} />
            </button>
        </OverlayTrigger>
      </Nav>
    )}
  </>
  );
}
export default SessionPanel;
